import { useEffect, useState } from 'react';
import type { ICustomControlDiagnosticReportReadProps } from '../../interfaces/customControlDiagnosticReportReadProps';
import { getDisplayName } from '../../../../../../common/utils/getDisplayName';
import { translateKey } from '../../../../../translate';
import { DiagnosticReportReadButtons } from '../../../../elements/carePathButtons/DiagnosticReportReadButtons';
import { UserTextParagraph } from '../../../../elements/common';
import { FormLabel } from '../../../../elements/forms/FormLabel';
import { HorizontalFormGroupRead } from '../../../../elements/forms/horizontalFormGroupRead/HorizontalFormGroupRead';
import { InputContainer } from '../../../../elements/forms/InputContainer';
import { ProcessContainer } from '../../../episodes/common';
import { ProcessItemFooter } from '../../../episodes/ProcessItemFooter';
import { ProcessItemHeader } from '../../../episodes/ProcessItemHeader';
import { CustomControlCollapseBody } from '../../utils/v1/CustomControlCollapseBody';
import { GtoV1DiagnosticReportSummary } from './GtoV1DiagnosticReportSummary';

export function GtoV1DiagnosticReportRead(props: ICustomControlDiagnosticReportReadProps) {
    const [isFooterVisible, setIsFooterVisible] = useState(false);

    useEffect(() => {
        checkIsFooterVisible();
    }, [props.diagnosticReport.customControlData]);

    const customControlData = props.diagnosticReport.customControlData;

    return (
        <ProcessContainer>
            <ProcessItemHeader
                date={props.diagnosticReport && props.diagnosticReport.dateSent}
                isFirstItem={props.isFirstItem}
                isItemOpen={props.itemState.isOpen}
                onToggle={async (isOpened) => await props.updateItemState({ ...props.itemState, isOpen: isOpened })}
                organizationName={props.diagnosticReport.performerOrganization?.name}
                practitionerName={
                    props.diagnosticReport.performerPractitioner
                        ? getDisplayName(props.diagnosticReport.performerPractitioner)
                        : undefined
                }
                process={props.process}
                title={translateKey('diagnosticReport.findings')}
            />

            <GtoV1DiagnosticReportSummary {...props} />

            <CustomControlCollapseBody isOpen={props.itemState.isOpen}>
                {customControlData?.toelichting && (
                    <HorizontalFormGroupRead>
                        <FormLabel>{translateKey('diagnosticReport.remarks')}</FormLabel>
                        <InputContainer>
                            <UserTextParagraph>{customControlData.toelichting}</UserTextParagraph>
                        </InputContainer>
                    </HorizontalFormGroupRead>
                )}

                {customControlData?.videoconsult && (
                    <HorizontalFormGroupRead>
                        <FormLabel>{translateKey('diagnosticReport.videoconsult')}</FormLabel>
                        <InputContainer>
                            <UserTextParagraph>{customControlData.videoconsult}</UserTextParagraph>
                        </InputContainer>
                    </HorizontalFormGroupRead>
                )}
            </CustomControlCollapseBody>

            {isFooterVisible && (
                <ProcessItemFooter
                    isItemOpen={props.itemState.isOpen}
                    labelLess={translateKey('diagnosticReport.hideExaminationReport')}
                    labelMore={translateKey('diagnosticReport.showExaminationReport')}
                    onToggle={async (isOpened) => await props.updateItemState({ ...props.itemState, isOpen: isOpened })}
                />
            )}
            <DiagnosticReportReadButtons {...props} />
        </ProcessContainer>
    );

    function checkIsFooterVisible() {
        const isVisible = !!customControlData.toelichting;
        setIsFooterVisible(isVisible);
    }
}
